if (!customElements.get('cart-pair-with')) {
  class CartPairWith extends HTMLElement {
    connectedCallback() {
      if (this.dataset.curated === 'true') return;
      this.load();
    }

    async load() {
      const productId = this.dataset.productId;
      if (!productId) return;

      const cartIds = new Set((this.dataset.cartIds || '').split(',').map(Number));
      try {
        let products = await this.fetchIntent(productId, 'complementary');
        if (!products.length) products = await this.fetchIntent(productId, 'related');
        const suggestions = products.filter((product) => product.available && !cartIds.has(product.id)).slice(0, 2);
        if (!this.isConnected) return;
        if (!suggestions.length) {
          this.remove();
          return;
        }
        this.querySelector('.cart-pair-with__items').innerHTML = suggestions.map((product) => this.renderCard(product)).join('');
        this.hidden = false;
      } catch (error) {
        if (this.isConnected) this.remove();
      }
    }

    async fetchIntent(productId, intent) {
      const response = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=6&intent=${intent}`);
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
      const data = await response.json();
      return data.products || [];
    }

    escapeHtml(value) {
      return String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      })[character]);
    }

    renderCard(product) {
      const title = this.escapeHtml(product.title);
      const url = this.escapeHtml(product.url);
      const image = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src;
      const imageUrl = image ? `${image}${image.includes('?') ? '&' : '?'}width=120` : '';
      const price = this.escapeHtml(`R ${(product.price_min / 100).toFixed(2)}`);
      return `
        <div class="cart-pair-with__item">
          <a class="cart-pair-with__image-link" href="${url}" aria-label="View ${title}">
            ${imageUrl ? `<img class="cart-pair-with__image" src="${this.escapeHtml(imageUrl)}" alt="${title}" width="60" height="60" loading="lazy">` : ''}
          </a>
          <div class="cart-pair-with__info">
            <a class="cart-pair-with__title" href="${url}">${title}</a>
            <span class="cart-pair-with__price">${product.price_varies ? 'From ' : ''}${price}</span>
          </div>
          <a class="cart-pair-with__view" href="${url}" aria-label="Choose options for ${title}">View</a>
        </div>`;
    }
  }

  customElements.define('cart-pair-with', CartPairWith);
}
